module.exports = "../../../../platform/assets/pageMainIcon/industry_baobiaochaxunlei6.svg";